import {Link} from "react-router-dom";

import "../Common.css"
import useScript from '../useScript';

function LegoChess()
{
    // useScript('https://cdnjs.cloudflare.com/ajax/libs/chess.js/0.10.2/chess.js');
    // useScript('../js/Games/LegoChess/phaser.min.js');
    // useScript('../js/Games/LegoChess/jquery-1.8.2.min.js');
    // useScript('../js/Games/LegoChess/jquery-ui-1.8.24.custom.min.js');
    // useScript('../js/Games/LegoChess/garbochess.js');
    // useScript('../js/Games/LegoChess/boardui.js');
    // useScript('../js/Games/LegoChess/startGame.js');
    // useScript('../js/Games/LegoChess/phaser-input.min.js');
    // useScript('../js/Games/LegoChess/phaser-kinetic-scrolling-plugin.min.js');
    // useScript('../js/Games/LegoChess/Marker.js');
    // useScript('../js/Games/LegoChess/ChessPiece.js');
    // useScript('../js/Games/LegoChess/Floor.js');
    // useScript('../js/Games/LegoChess/boot.js');
    // useScript('../js/Games/LegoChess/start.js');
    // useScript('../js/Games/LegoChess/menu.js');
    // useScript('../js/Games/LegoChess/menu2.js');
    // useScript('../js/Games/LegoChess/gameplay.js');
    // useScript('../js/Games/LegoChess/game.js');
    useScript('../js/Games/LegoChess/allLegoChess.js');

    return (
        <div className="top-buffer">
            <p>Lego Chess</p>
            <div id="game1"></div>
            <Link to="/Games" className="logo"></Link>
        </div>
      )
}

export default LegoChess;